import { createReducer } from '@reduxjs/toolkit'

const alert = createReducer({}, {
    SHOW_ALERT: (state, action) => {
        console.log(' alert reducer', action);
        state.open = action.payload;
    },
});

export default alert;